import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IoChevronBack } from 'react-icons/io5';
const PageHeader = ({ title, onBack, rightAction, showBack = true }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <Header>
      <Left>
        {showBack && (
          <BackButton onClick={handleBack}>
            <IoChevronBack size={24} />
          </BackButton>
        )}
        <Title>{title}</Title>
      </Left>
      {rightAction && <Right>{rightAction}</Right>}
    </Header>
  );
};

export default PageHeader;

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  color: ${({ theme }) => theme.colors.text.primary};
  min-height: 56px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BackButton = styled.button`
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  align-items: center;
`;

const Title = styled.p`
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: 700;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
